// extracted by mini-css-extract-plugin
export default {"onboardingLink":"OnboardingLinks_onboardingLink__BU89p","backarrow":"OnboardingLinks_backarrow__wK4YY","divider":"OnboardingLinks_divider__4JRnn"};